module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/hamburger-33f725c5e2512c5e03754d112b07b6ba.svg";